import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // skipGtag: the server already reported this event to GA4 (Measurement
  // Protocol), so only the Bing side fires here.
  static values = { event: String, params: Object, autoFire: Boolean, skipGtag: Boolean }

  connect() {
    if (this.autoFireValue) this.track()
  }

  track() {
    const params = this.hasParamsValue ? this.paramsValue : {}

    // Google Analytics / Google Ads
    if (!this.skipGtagValue && typeof window.gtag === "function") {
      window.gtag("event", this.eventValue, params)
    }

    // Microsoft Advertising (Bing UET) — mirror the same event.
    // uetq is an Array before bat.js loads and a UET instance after; both expose push().
    if (window.uetq && typeof window.uetq.push === "function") {
      const uetParams = {}
      if (params.value != null) uetParams.revenue_value = params.value
      if (params.currency) uetParams.currency = params.currency
      if (params.transaction_id) uetParams.transaction_id = params.transaction_id
      window.uetq.push("event", this.eventValue, uetParams)
    }
  }
}
